/**
 * @generated SignedSource<<bf51b0ef2ef63bbae2a35217d5605f39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DevAiFlowPipelinesStatus = "FAILED" | "IN_PROGRESS" | "PROVISIONED" | "STARTING" | "STOPPED" | "%future added value";
export type DevAiFlowSessionsStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PAUSED" | "PENDING" | "%future added value";
export type flowScreen_loadFlowQuery$variables = {
  cloudId: string;
  sessionId: string;
};
export type flowScreen_loadFlowQuery$data = {
  readonly devai_flowSessionGetByIDAndCloudID: {
    readonly additionalInfoJSON: string | null;
    readonly createdAt: string | null;
    readonly id: string;
    readonly pipelines: ReadonlyArray<{
      readonly status: DevAiFlowPipelinesStatus | null;
      readonly url: string | null;
    } | null> | null;
    readonly status: DevAiFlowSessionsStatus | null;
  } | null;
};
export type flowScreen_loadFlowQuery = {
  response: flowScreen_loadFlowQuery$data;
  variables: flowScreen_loadFlowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "sessionId",
    "variableName": "sessionId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalInfoJSON",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "flowScreen_loadFlowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "devai_flowSessionGetByIDAndCloudID",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DevAiFlowPipeline",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "flowScreen_loadFlowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "devai_flowSessionGetByIDAndCloudID",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DevAiFlowPipeline",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7a709eb7db4e83e4e978cade7866cac",
    "id": null,
    "metadata": {},
    "name": "flowScreen_loadFlowQuery",
    "operationKind": "query",
    "text": "query flowScreen_loadFlowQuery(\n  $sessionId: ID!\n  $cloudId: ID!\n) {\n  devai_flowSessionGetByIDAndCloudID(sessionId: $sessionId, cloudId: $cloudId) @optIn(to: \"DevAiFlowSessionGetByIDAndCloudID\") {\n    id\n    createdAt\n    status\n    additionalInfoJSON\n    pipelines {\n      status\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f0e1d26b6a07a82e822647006422c30";

export default node;
